import React from 'react'
import { List, ListItem, Typography } from '@mui/material'

import { withStyles } from 'tss-react/mui'
import RoomsStatsPopup from '@app/containers/MyEnergy/Tabs/RoomStats/RoomsStatsPopup'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import styles from './RoomsStatsItemList.style'
import RoomsStatsItem from './RoomsStatsItem'

interface Props {
  classes: Record<string, string>,
  className?: string,
  RoomsStatsItems: any[],
  isRoomsStatsPopupOpen: boolean,
  isMobile: boolean,
  openRoomStatsPopup: (...args: any[]) => void,
  selectCurrentRoomIdAndName: (...args: any[]) => void,
  syncCurrentRoomStats: (...args: any[]) => void,
}

class RoomsStatsItemList extends React.Component<Props> {
  render() {
    const {
      classes,
      RoomsStatsItems,
      isRoomsStatsPopupOpen,
      isMobile,
      openRoomStatsPopup,
      selectCurrentRoomIdAndName,
      syncCurrentRoomStats,
    } = this.props
    return (
      <Wrapper>
        <List className={classes.root}>
          {RoomsStatsItems.length
            ? RoomsStatsItems.map((room) => (
              <ListItem
                className={classes.listItem}
                key={room.id}
              >
                <RoomsStatsItem
                  className={classes.deviceItem}
                  name={room.name}
                  billing={room.billing}
                  energy={room.energy}
                  isRoomsStatsPopupOpen={isRoomsStatsPopupOpen}
                  isMobile={isMobile}
                  openRoomStatsPopup={openRoomStatsPopup}
                  id={room.id}
                  selectCurrentRoomIdAndName={selectCurrentRoomIdAndName}
                  syncCurrentRoomStats={syncCurrentRoomStats}
                />
              </ListItem>
            )) : <Typography align="center" variant="h6">{I18n.t('my_energy.no_rooms')}</Typography>}
        </List>
        {isRoomsStatsPopupOpen && (
          <RoomsStatsPopup />
        )}
      </Wrapper>
    )
  }
}
export default withStyles(RoomsStatsItemList, styles as any) as unknown as React.ComponentType<Omit<Props, 'classes'>>
